module.exports = __webpack_public_path__ + "static/media/trending-screen.24177c54.mov";